import {
  CHANGE_PASSWORD_RESET,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FALIURE
} from './ChangePasswordConstants'
import {config} from '../config'

export const changePasswordReset = (change_password_req) =>{
  return{
    type : CHANGE_PASSWORD_RESET,
    payload : change_password_req
  }
}

export const changePasswordRequest = (change_password_req) =>{
  return{
    type : CHANGE_PASSWORD_REQUEST,
    payload : change_password_req
  }
}

export const changePasswordSuccess = (change_password_success) =>{
  return{
    type : CHANGE_PASSWORD_SUCCESS,
    payload : change_password_success
  }
}

export const changePasswordFaliure = (error) =>{
  return{
    type : CHANGE_PASSWORD_FALIURE,
    payload : error
  }
}

export const initPassword = () =>{
  return(dispatch) => {
    dispatch(changePasswordReset(""))
  }
}  


export const changePassword = (newPassword) =>{
  return(dispatch) => {
    dispatch(changePasswordRequest(newPassword))
    const url =`${config.api_root}/api/v1/users/change_password`
    const request_option = {
       method: "POST",
       headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer '+ config.token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "fields": {
            "new_password": newPassword
          },
          "form_id": "",
          "user_id": config.user_id
        })
      }
    
    fetch(url, request_option)
     .then(response => response.json() )
     .then(res =>{
        const res_success = res;
        if(res_success.request_status) {
           dispatch(changePasswordSuccess(res_success));
        } else {
           dispatch(changePasswordFaliure(res_success));
        }
     })
    .catch(error => {
      const errorMsg = error
      dispatch(changePasswordFaliure(errorMsg))
    })
  }
}
